import { StyledTab, StyledTabs } from 'common/components/StyledTabs'

import { IWisDetailsModalTabsProps } from './types'

export const WisDetailsModalTabs = ({
  state1,
  state2,
  currentState,
  onChange
}: IWisDetailsModalTabsProps) => {
  if (!state2) {
    return null
  }

  return (
    <div className='px-6'>
      <StyledTabs value={currentState} onChange={onChange}>
        <StyledTab label={state1?.name} value={state1} />
        <StyledTab label={state2?.name} value={state2} />
      </StyledTabs>
    </div>
  )
}

export default WisDetailsModalTabs
